import { __extends } from "tslib";
import { BaseAdapter } from '../../core/adapters/base-adapter';
/**
 * The DOM adapter behind the `<tcw-option>` element.
 */
var OptionAdapter = /** @class */ (function (_super) {
    __extends(OptionAdapter, _super);
    function OptionAdapter(component) {
        return _super.call(this, component) || this;
    }
    return OptionAdapter;
}(BaseAdapter));
export { OptionAdapter };
